// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Note-module__root--vFWLV {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  min-height: 68px;
  flex-direction: column;
  align-items: flex-start;
  padding: 14px 14px 14px 16px;
  border-left: 2px solid #1a1a1a;
  background-color: #fff4df;
  color: #000;
  font-size: 0.875rem; /* 14px */
  font-weight: 400;
  line-height: 1.5833;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.Note-module__root--vFWLV .Note-module__title--N7mMs {
  margin: 0;
  font-size: 0.6875rem; /* 11px */
  font-weight: 700;
  color: #A05A27;
  padding-bottom: 4px;
}

.Note-module__variant-default--nVdHn {
  border-left-color: #a3a09c;
  background-color: #efeeec;
  color: #1a1a1a;
  font-family: 'Noto Serif KR', serif;
  font-size: 1.125rem; /* 18px */
  font-weight: 600;
  line-height: 1.6;
}

.Note-module__variant-subtle--E8NrN {
  border-left-color: #1A1A1A;
  background-color: #F0ECE5;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Note/Note.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,cAAc;EACd,mCAAmC;EACnC,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B","sourcesContent":[".root {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  min-height: 68px;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 14px 14px 14px 16px;\n  border-left: 2px solid #1a1a1a;\n  background-color: #fff4df;\n  color: #000;\n  font-size: 0.875rem; /* 14px */\n  font-weight: 400;\n  line-height: 1.5833;\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n}\n\n.root .title {\n  margin: 0;\n  font-size: 0.6875rem; /* 11px */\n  font-weight: 700;\n  color: #A05A27;\n  padding-bottom: 4px;\n}\n\n.variant-default {\n  border-left-color: #a3a09c;\n  background-color: #efeeec;\n  color: #1a1a1a;\n  font-family: 'Noto Serif KR', serif;\n  font-size: 1.125rem; /* 18px */\n  font-weight: 600;\n  line-height: 1.6;\n}\n\n.variant-subtle {\n  border-left-color: #1A1A1A;\n  background-color: #F0ECE5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Note-module__root--vFWLV`,
	"title": `Note-module__title--N7mMs`,
	"variant-default": `Note-module__variant-default--nVdHn`,
	"variant-subtle": `Note-module__variant-subtle--E8NrN`
};
export default ___CSS_LOADER_EXPORT___;
